// src/encounter/services/care-model-run-api.ts
// What one care-model run is doing, and the checklist tick, from the practitioner app. The same Scrips.Workflows reads
// and write pm-react's studio run view makes (`src/studio/services/care-model-run-api.ts`): the calls are copied, the
// UI is not. Bodies come back as `unknown`; the typed boundary is `@/patients/lib/care-model-tasks`.
//
//   GET  /workflows/care-models/enrolments/{enrolmentId}/run    → { data: { workflowInstanceId, … } }
//   GET  /v1/workflow-instances/{id}                             → { id, definitionVersionId, workflowStatus, variables, activityData }
//   GET  /v1/workflow-instances/{id}/execution-log               → { items: [{ activityId, eventName, timestamp, data }] }
//   GET  /v1/workflow-definitions/{definitionVersionId}          → the definition version the run used (step titles, items)
//   POST /workflows/checklists/{instanceId}/{activityId}/items/{label}/complete   (CompleteChecklistItemController, PROD-1005 D4)
//
// All four reads answered 200 for the dev physician persona (hassan) on 23 Oct 2026. Tenant scope is the server's,
// from the token: a run outside the caller's organisation answers 404.
import { getWorkflows, postWorkflows } from '@/shared/api/api-client';

const seg = encodeURIComponent;

export function fetchEnrolmentRun(enrolmentId: string, signal?: AbortSignal): Promise<unknown> {
  return getWorkflows<unknown>(`/workflows/care-models/enrolments/${seg(enrolmentId)}/run`, { signal });
}

export function fetchWorkflowInstance(instanceId: string, signal?: AbortSignal): Promise<unknown> {
  return getWorkflows<unknown>(`/v1/workflow-instances/${seg(instanceId)}`, { signal });
}

export function fetchExecutionLog(instanceId: string, signal?: AbortSignal): Promise<unknown> {
  return getWorkflows<unknown>(`/v1/workflow-instances/${seg(instanceId)}/execution-log`, { signal });
}

export function fetchDefinitionVersion(definitionVersionId: string, signal?: AbortSignal): Promise<unknown> {
  return getWorkflows<unknown>(`/v1/workflow-definitions/${seg(definitionVersionId)}`, { signal });
}

/** Tick one checklist item. The engine marks it, wakes the suspended step, and the step moves on when every item is done. */
export function completeChecklistItem(instanceId: string, activityId: string, label: string): Promise<unknown> {
  const path = ['workflows', 'checklists', instanceId, activityId, 'items', label].map(seg).join('/');
  return postWorkflows<unknown>(`/${path}/complete`, undefined);
}
